import { Link, Stack, Table, TableBody, TableHead, TableRow } from '@mui/material';

import {
  GeneralTableBox,
  HeadTableCell,
  PaginationTable,
  RowTableCell,
} from '../../../../common/components';
import { formatDateTime } from '../../utils/puntajeFormatters';
import TableStateRow from '../common/TableStateRow';

const LotteryResultsTable = ({ rows, isLoading, pagination }) => (
  <>
    <GeneralTableBox>
      <Table>
        <TableHead>
          <TableRow>
            <HeadTableCell>Periodo</HeadTableCell>
            <HeadTableCell>Fecha sorteo</HeadTableCell>
            <HeadTableCell>Numero</HeadTableCell>
            <HeadTableCell>Ultimos 3</HeadTableCell>
            <HeadTableCell>Origen</HeadTableCell>
            <HeadTableCell>Evidencia</HeadTableCell>
            <HeadTableCell>Observaciones</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!rows.length ? (
            <TableStateRow
              colSpan={7}
              loading={isLoading}
              emptyMessage="No hay resultados de loteria cargados."
            />
          ) : (
            rows.map((row) => (
              <TableRow key={row.uuid} hover>
                <RowTableCell>
                  {String(row.month).padStart(2, '0')}/{row.year}
                </RowTableCell>
                <RowTableCell>{formatDateTime(row.draw_date, false)}</RowTableCell>
                <RowTableCell sx={{ fontWeight: 600 }}>{row.full_number}</RowTableCell>
                <RowTableCell>{row.last_three_digits}</RowTableCell>
                <RowTableCell>{row.source_type}</RowTableCell>
                <RowTableCell>
                  <Stack spacing={0.5} alignItems="flex-start">
                    {row.source_url ? (
                      <Link href={row.source_url} target="_blank" rel="noreferrer" underline="hover">
                        Fuente
                      </Link>
                    ) : null}
                    {row.screenshot_url ? (
                      <Link href={row.screenshot_url} target="_blank" rel="noreferrer" underline="hover">
                        Screenshot
                      </Link>
                    ) : null}
                    {!row.source_url && !row.screenshot_url ? '-' : null}
                  </Stack>
                </RowTableCell>
                <RowTableCell>{row.observations || '-'}</RowTableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
    {!!pagination?.totalCount && (
      <PaginationTable
        page={pagination.page}
        totalPages={pagination.totalPages}
        totalCount={pagination.totalCount}
        rowsPerPage={pagination.rowsPerPage}
        onPageChange={pagination.handlePageChange}
        onRowsPerPageChange={pagination.handleRowsPerPageChange}
      />
    )}
  </>
);

export default LotteryResultsTable;
